import {
  PROJECTCATEGORY,
  PROJECTINFO,
  PROJECT_REQUEST,
} from "../actions/utilities";

const INITIAL_STATE = {
  getProjectsLoading: false,
  getProjectsSuccess: false,
  getProjectsFailure: false,
  getProjectsError: null,
  getNextProjectsLoading: false,
  getNextProjectsSuccess: false,
  getNextProjectsFailure: false,
  getNextProjectsError: null,
  addProjectLoading: false,
  addProjectSuccess: false,
  addProjectFailure: false,
  addProjectError: null,
  editProjectLoading: false,
  editProjectSuccess: false,
  editProjectFailure: false,
  editProjectError: null,
  getProjectCategoryLoading: false,
  getProjectCategorySuccess: false,
  getProjectCategoryFailure: false,
  getProjectCategoryError: null,
  getProjectInfoLoading: false,
  getProjectInfoSuccess: false,
  getProjectInfoFailure: false,
  getProjectInfoError: null,

  deleteProjectLoading: false,
  deleteProjectSuccess: false,
  deleteProjectFailure: false,
  deleteProjectError: null,

  projectsList: [],
  EmployeeProjectsList: [],
  EmployeeTasksList: [],

  projectCategory: [],
  projectInfo: null,
  nextProject: false,
  currentProject: null,

  projectSelectListByRoleLoading: false,
  projectSelectListByRoleSuccess: false,
  projectSelectListByRoleFailure: false,
  projectSelectListByRoleError: null,
  projectSelectListByRole: [],

  getDeleteProjectListLoading: false,
  getDeleteProjectListSuccess: false,
  getDeleteProjectListFailure: false,
  getDeleteProjectListError: null,
  deleteProjectList: [],

  restoreDeleteProjectLoading: false,
  restoreDeleteProjectSuccess: false,
  restoreDeleteProjectFailure: false,
  restoreDeleteProjectError: null,

  emptyTrashProjectLoading: false,
  emptyTrashProjectSuccess: false,
  emptyTrashProjectFailure: false,
  emptyTrashProjectError: null,

  deleteTrashProjectLoading: false,
  deleteTrashProjectSuccess: false,
  deleteTrashProjectFailure: false,
  deleteTrashProjectError: null,
};

export const projectReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    //get projects for employees

    case PROJECT_REQUEST.REMOVE_USER_FROM_PROJECT_REQUEST:
      return {
        ...state,
        removeUserLoading: true,
        removeUserSuccess: false,
        removeUserFailure: false,
        removeUserError: null,
      };
    case PROJECT_REQUEST.REMOVE_USER_FROM_PROJECT_SUCCESS:
      const { projectId, userId } = action.payload;
      const updatedProject = state.projectsList.find(
        (proj) => proj.projectId === projectId,
      );

      if (updatedProject) {
        updatedProject.projectTeamMembers =
          updatedProject.projectTeamMembers.filter(
            (member) => member.userId !== userId,
          );
      }

      return {
        ...state,
        removeUserLoading: false,
        removeUserSuccess: true,
        removeUserFailure: false,
        removeUserError: null,
        removeUserMessage: action.payload.message,
      };
    case PROJECT_REQUEST.REMOVE_USER_FROM_PROJECT_FAILURE:
      return {
        ...state,
        removeUserLoading: false,
        removeUserSuccess: false,
        removeUserFailure: true,
        removeUserError: action.error,
      };

    case PROJECT_REQUEST.GET_PROJECTS_BY_EMPLOYEE_REQUEST:
      return {
        ...state,
        getProjectsLoading: true,
        getProjectsSuccess: false,
        getProjectsFailure: false,
        getProjectsError: null,
      };
    case PROJECT_REQUEST.GET_PROJECTS_BY_EMPLOYEE_SUCCESS:
      //  ;
      // if (action.payload != null) {
      //   if (action.payload.length > 7) state.nextProject = true;
      //  state.EmployeeProjectsList = [...action.payload];
      // } else {
      //   state.nextProject = false;
      // }
      // state.EmployeeProjectsList = [...action.payload];

      return {
        ...state,
        getProjectsLoading: false,
        getProjectsSuccess: true,
        getProjectsFailure: false,
        getProjectsError: null,
        EmployeeProjectsList: action.payload,

        //  EmployeeProjectsList: action.payload,
      };
    case PROJECT_REQUEST.GET_PROJECTS_BY_EMPLOYEE_FAILURE:
      return {
        ...state,
        getProjectsLoading: false,
        getProjectsSuccess: false,
        getProjectsFailure: true,
        getProjectsError: action.payload,
      };

    //get employee task related to project
    case PROJECT_REQUEST.GET_EMPLOYEE_TASKS_REQUEST:
      return {
        ...state,
        getProjectsLoading: true,
        getProjectsSuccess: false,
        getProjectsFailure: false,
        getProjectsError: null,
      };

    case PROJECT_REQUEST.GET_EMPLOYEE_TASKS_SUCCESS:
      return {
        ...state,
        getEmployeeTasksLoading: false,
        getEmployeeTasksSuccess: true,
        getEmployeeTasksFailure: false,
        getEmployeeTasksError: null,
        EmployeeTasksList: action.payload,
      };

    case PROJECT_REQUEST.GET_EMPLOYEE_TASKS_FAILURE:
      return {
        ...state,
        getProjectsLoading: false,
        getProjectsSuccess: false,
        getProjectsFailure: true,
        getProjectsError: action.payload,
      };

    // add project
    case PROJECT_REQUEST.GET_PROJECT_REQUEST:
      return {
        ...state,
        getProjectsLoading: true,
        getProjectsSuccess: false,
        getProjectsFailure: false,
        getProjectsError: null,
      };
    case PROJECT_REQUEST.GET_PROJECT_SUCCESS:
      //  ;
      if (action.payload != null) {
        if (action.payload.length > 7) state.nextProject = true;
        state.projectsList = [...action.payload];
      } else {
        state.nextProject = false;
      }

      return {
        ...state,
        getProjectsLoading: false,
        getProjectsSuccess: true,
        getProjectsFailure: false,
        getProjectsError: null,
      };
    case PROJECT_REQUEST.GET_PROJECT_FAILURE:
      return {
        ...state,
        getProjectsLoading: false,
        getProjectsSuccess: false,
        getProjectsFailure: true,
        getProjectsError: action.payload,
      };
    //
    // get NEXT project
    case PROJECT_REQUEST.GET_NEXT_PROJECT_REQUEST:
      return {
        ...state,
        getNextProjectsSuccess: false,
        getNextProjectsLoading: true,
        getNextProjectsFailure: false,
        getNextProjectsError: null,
      };
    case PROJECT_REQUEST.GET_NEXT_PROJECT_SUCCESS:
      if (action.payload != null) {
        state.projectsList = state.projectsList.concat(action.payload);
        state.nextProject = true;
      } else {
        state.nextProject = false;
      }

      return {
        ...state,
        getNextProjectsLoading: false,
        getNextProjectsSuccess: true,
        getNextProjectsFailure: false,
        getNextProjectsError: null,
      };
    case PROJECT_REQUEST.GET_NEXT_PROJECT_FAILURE:
      return {
        ...state,
        getNextProjectsLoading: false,
        getNextProjectsSuccess: false,
        getNextProjectsFailure: true,
        getNextProjectsError: action.payload,
      };
    //
    case PROJECT_REQUEST.ADD_PROJECT_REQUEST:
      return {
        ...state,
        addProjectLoading: true,
        addProjectSuccess: false,
        addProjectFailure: false,
        addProjectError: null,
      };
    case PROJECT_REQUEST.ADD_PROJECT_SUCCESS:
      let currentProjects = [...state.projectsList];
      currentProjects.push(action.payload[0]);
      return {
        ...state,
        addProjectLoading: false,
        addProjectSuccess: true,
        addProjectFailure: false,
        addProjectError: null,
        projectsList: currentProjects,
      };
    case PROJECT_REQUEST.ADD_PROJECT_FAILURE:
      return {
        ...state,
        addProjectLoading: false,
        addProjectSuccess: false,
        addProjectFailure: true,
        addProjectError: action.payload,
      };
    case PROJECT_REQUEST.EDIT_PROJECT_REQUEST:
      return {
        ...state,
        editProjectLoading: true,
        editProjectSuccess: false,
        editProjectFailure: false,
        editProjectError: null,
      };
    case PROJECT_REQUEST.EDIT_PROJECT_SUCCESS:
      let projects_ = state.projectsList;

      for (let i = 0; i < projects_.length; i++) {
        if (projects_[i].projectId === action?.payload[i]?.projectId) {
          projects_[i] = action?.payload[i];
        }
      }
      return {
        ...state,
        editProjectLoading: false,
        editProjectSuccess: true,
        editProjectFailure: false,
        editProjectError: null,
        projectsList: projects_,
      };
    case PROJECT_REQUEST.EDIT_PROJECT_FAILURE:
      return {
        ...state,
        editProjectLoading: false,
        editProjectSuccess: false,
        editProjectFailure: true,
        editProjectError: action.payload,
      };
    case PROJECT_REQUEST.DELETE_PROJECT_REQUEST:
      return {
        ...state,
        deleteProjectLoading: true,
        deleteProjectSuccess: false,
        deleteProjectFailure: false,
        deleteProjectError: null,
      };
    case PROJECT_REQUEST.DELETE_PROJECT_SUCCESS:
      return {
        ...state,
        deleteProjectLoading: false,
        deleteProjectSuccess: true,
        deleteProjectFailure: false,
        deleteProjectError: null,
      };
    case PROJECT_REQUEST.DELETE_PROJECT_FAILURE:
      return {
        ...state,
        deleteProjectLoading: false,
        deleteProjectSuccess: false,
        deleteProjectFailure: true,
        deleteProjectError: action.payload,
      };
    case PROJECTCATEGORY.GET_PROJECT_CATEGORY_REQUEST:
      return {
        ...state,
        getProjectCategoryLoading: true,
        getProjectCategorySuccess: false,
        getProjectCategoryFailure: false,
        getProjectCategoryError: null,
      };
    case PROJECTCATEGORY.GET_PROJECT_CATEGORY_SUCCESS:
      return {
        ...state,
        getProjectCategoryLoading: false,
        getProjectCategorySuccess: true,
        getProjectCategoryFailure: false,
        getProjectCategoryError: null,
        projectCategory: action.payload,
      };
    case PROJECTCATEGORY.GET_PROJECT_CATEGORY_FAILURE:
      return {
        ...state,
        getProjectCategoryLoading: false,
        getProjectCategorySuccess: false,
        getProjectCategoryFailure: true,
        getProjectCategoryError: action.payload,
      };
    //PROJECT INFO => CLIENTS And Categories
    case PROJECTINFO.GET_PROJECT_INFO_REQUEST:
      return {
        ...state,
        getProjectInfoLoading: true,
        getProjectInfoSuccess: false,
        getProjectInfoFailure: false,
        getProjectInfoError: null,
      };
    case PROJECTINFO.GET_PROJECT_INFO_SUCCESS:
      state.projectInfo = action.payload;
      return {
        ...state,
        getProjectInfoLoading: false,
        getProjectInfoSuccess: true,
        getProjectInfoFailure: false,
        getProjectInfoError: null,
      };
    case PROJECTINFO.GET_PROJECT_INFO_FAILURE:
      return {
        ...state,
        getProjectInfoLoading: false,
        getProjectInfoSuccess: false,
        getProjectInfoFailure: true,
        getProjectInfoError: action.payload,
      };
    case PROJECT_REQUEST.SET_CURRENT_PROJECT_SUCCESS:
      //  ;
      state.currentProject = action.payload;
      return {
        ...state,
        getProjectsSuccess: true,
      };
    case PROJECT_REQUEST.GET_PROJECT_ON_RELOAD_SUCCESS:
      if (action.payload != null) {
        state.currentProject = {
          ...action.payload,
          projectMileStoneId:
            action.payload.activeMilesStoneId ||
            action.payload.projectMileStoneId,
        };
      }

      return {
        ...state,
        getProjectsSuccess: true,
      };

    case PROJECT_REQUEST.GET_PROJECT_SELECT_LIST_BY_ROLE_REQUEST:
      return {
        ...state,
        projectSelectListByRoleLoading: true,
        projectSelectListByRoleSuccess: false,
        projectSelectListByRoleFailure: false,
        projectSelectListByRoleError: null,
        projectSelectListByRole: [],
      };

    case PROJECT_REQUEST.GET_PROJECT_SELECT_LIST_BY_ROLE_SUCCESS:
      return {
        ...state,
        projectSelectListByRoleLoading: false,
        projectSelectListByRoleSuccess: true,
        projectSelectListByRoleFailure: false,
        projectSelectListByRoleError: null,
        projectSelectListByRole: action.payload,
      };

    case PROJECT_REQUEST.GET_PROJECT_SELECT_LIST_BY_ROLE_FAILURE:
      return {
        ...state,
        projectSelectListByRoleLoading: false,
        projectSelectListByRoleSuccess: false,
        projectSelectListByRoleFailure: true,
        projectSelectListByRoleError: action.payload,
      };
    case PROJECT_REQUEST.GET_DELETE_PROJECT_LIST_REQUEST:
      return {
        ...state,
        getDeleteProjectListLoading: true,
        getDeleteProjectListSuccess: false,
        getDeleteProjectListFailure: false,
        getDeleteProjectListError: null,
      };
    case PROJECT_REQUEST.GET_DELETE_PROJECT_LIST_SUCCESS:
      return {
        ...state,
        getDeleteProjectListLoading: false,
        getDeleteProjectListSuccess: true,
        getDeleteProjectListFailure: false,
        getDeleteProjectListError: null,
        deleteProjectList: action.payload,
      };
    case PROJECT_REQUEST.GET_DELETE_PROJECT_LIST_FAILURE:
      return {
        ...state,
        getDeleteProjectListLoading: false,
        getDeleteProjectListSuccess: false,
        getDeleteProjectListFailure: true,
        getDeleteProjectListError: action.payload,
      };
    case PROJECT_REQUEST.RESTORE_DELETE_PROJECT_REQUEST:
      return {
        ...state,
        restoreDeleteProjectLoading: true,
        restoreDeleteProjectSuccess: false,
        restoreDeleteProjectFailure: false,
        restoreDeleteProjectError: null,
      };
    case PROJECT_REQUEST.RESTORE_DELETE_PROJECT_SUCCESS:
      return {
        ...state,
        restoreDeleteProjectLoading: false,
        restoreDeleteProjectSuccess: true,
        restoreDeleteProjectFailure: false,
        restoreDeleteProjectError: null,
      };
    case PROJECT_REQUEST.RESTORE_DELETE_PROJECT_FAILURE:
      return {
        ...state,
        restoreDeleteProjectLoading: false,
        restoreDeleteProjectSuccess: false,
        restoreDeleteProjectFailure: true,
        restoreDeleteProjectError: action.payload,
      };
    case PROJECT_REQUEST.EMPTY_TRASH_PROJECT_REQUEST:
      return {
        ...state,
        emptyTrashProjectLoading: true,
        emptyTrashProjectSuccess: false,
        emptyTrashProjectFailure: false,
        emptyTrashProjectError: null,
      };
    case PROJECT_REQUEST.EMPTY_TRASH_PROJECT_SUCCESS:
      return {
        ...state,
        emptyTrashProjectLoading: false,
        emptyTrashProjectSuccess: true,
        emptyTrashProjectFailure: false,
        emptyTrashProjectError: null,
      };
    case PROJECT_REQUEST.EMPTY_TRASH_PROJECT_FAILURE:
      return {
        ...state,
        emptyTrashProjectLoading: false,
        emptyTrashProjectSuccess: false,
        emptyTrashProjectFailure: true,
        emptyTrashProjectError: action.payload,
      };
    case PROJECT_REQUEST.DELETE_TRASH_PROJECT_REQUEST:
      return {
        ...state,
        deleteTrashProjectLoading: true,
        deleteTrashProjectSuccess: false,
        deleteTrashProjectFailure: false,
        deleteTrashProjectError: null,
      };
    case PROJECT_REQUEST.DELETE_TRASH_PROJECT_SUCCESS:
      return {
        ...state,
        deleteTrashProjectLoading: false,
        deleteTrashProjectSuccess: true,
        deleteTrashProjectFailure: false,
        deleteTrashProjectError: null,
      };
    case PROJECT_REQUEST.DELETE_TRASH_PROJECT_FAILURE:
      return {
        ...state,
        deleteTrashProjectLoading: false,
        deleteTrashProjectSuccess: false,
        deleteTrashProjectFailure: true,
        deleteTrashProjectError: action.payload,
      };
    default:
      return state;
  }
};
